import React from "react";
import { connect } from "react-redux";
import { Route } from "react-router-dom";

import { setAndPrepareStateParam, getCleanURL } from "../../helpers/URLHelper";
import { setQueryParams } from  "../../actions/queryParamsAction";
import { setFeedbackDetails } from "../../actions/userDataActions";
import { setPreferenceDetails } from "../../actions/preferencesActions";
import TranslationDataFetcher from "../../dataFetchers/translationsDataFetcher";
import { Configuration } from "../../configs/Configuration";
import { getBECompatibleLocale, prepareColorsData, replaceColorsInCss } from "../../helpers/helper";
import ConfigDataFetcher from "../../dataFetchers/configsDataFetcher";
import BCLLoading from "../common/Loading/BCLLoading";
import StandaloneMain from "./StandaloneMain";

class StandaloneContainer extends React.Component {
  configuration = Configuration.getConfiguration();

  componentDidMount() {
    const { location, fetchConfigData, fetchColorPaletteData } = this.props;

    fetchConfigData({ pilotId: this.configuration.pilotId });
    fetchColorPaletteData({ pilotId: this.configuration.pilotId});
    let queryParams = setAndPrepareStateParam(location, true);
    let preferenceDetails = setAndPrepareStateParam(location, false);

    if (Object.keys(queryParams).length > 0) {
      this.props.setFeedbackDetails(queryParams);
      this.props.setQueryParams(queryParams);
    }
    if (preferenceDetails && preferenceDetails.tabType) {
      this.props.setPreferenceDetails(preferenceDetails);
    }
    this.props.history.push(getCleanURL(location));
  }

  componentDidUpdate(prevProps) {
    if (!prevProps.configs.data && this.props.configs && this.props.configs.data) {
      this.props.fetchAllTranslations({ pilotId: this.configuration.pilotId, locale: getBECompatibleLocale(this.props.configs.data) });
      let faviconId = document.getElementById("favicon");
      faviconId.href = this.props.configs.data["favicon"];
    }

    if (!prevProps.configs.data || (!prevProps.configs.colorPallete) && this.props.configs.colorPallete) {
      if (this.props.configs && this.props.configs.colorPallete) {
        const COLORS_TO_REPLACE = prepareColorsData(this.props.configs.colorPallete);
        replaceColorsInCss(COLORS_TO_REPLACE);
      }
    }
  }

  render() {
    return (
      <>
      { this.props.configs && this.props.configs.colorPallete && this.props.configs.data && this.props.translationsData && this.props.translationsData.data ? <Route component={StandaloneMain} /> : <BCLLoading />}
      </>
    );
  }
}

const mapStateToProps = state => {
  return {
    feedbackType: state.feedbackType,
    configs: state.configs,
    translationsData: state.translationsData
  };
};

const mapDispatchToProps = dispatch => {
  return {
    setFeedbackDetails: feedbackDetails => dispatch(setFeedbackDetails(feedbackDetails)),
    fetchConfigData: options => dispatch(ConfigDataFetcher.fetchConfigData(options)),
    fetchAllTranslations: options => dispatch(TranslationDataFetcher.fetchAllTranslations(options)),
    fetchColorPaletteData: options => dispatch(ConfigDataFetcher.fetchColorPaletteData(options)),
    setPreferenceDetails: preferenceDetails => dispatch(setPreferenceDetails(preferenceDetails)),
    setQueryParams: queryParams => dispatch(setQueryParams(queryParams))
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(StandaloneContainer);
